export const PAYMENT_TYPES_DEFAULT = {
  braintree: 0,
  paypal: 1,
  polipay: 2,
  onAccount: 3,
};

export const PAYMENT_TYPES_CCC = {
  ...PAYMENT_TYPES_DEFAULT,
  voucher: 4,
  applePay: 5,
};

Object.freeze(PAYMENT_TYPES_CCC);

export const PAYMENT_TYPES_SEALINK = {
  ...PAYMENT_TYPES_DEFAULT,
  savedCard: 4,
  applePay: 5,
};

export const SPECIAL_EVENT_PRODUCT_KEY = 'Special Event';

export const OPTIONAL_EXTRA_PRODUCT_TYPE_ID = 22;

export const HIGH_VOLUME_IMPORT_VEHICLE = 'HIGH_VOLUME_IMPORT_VEHICLE';

export const IS_ONE_SEALINK = window.ecom.craftConfig.tenant === 'sealink';
